import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarGradePremiacao, setModalDeletarGradePremiacao } from "../redux/slices/gradePremiacao/gradePremiacaoSlice";

export const cadastrarGradePremiacao = createAsyncThunk("/GradePremiacao/CadastrarGradePremiacao", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/GradePremiacao/CadastrarGradePremiacao", payload.value);
    toastSucess("Grade de premiação cadastrada com sucesso");
    dispatch(setModalCadastrarGradePremiacao(false));
    dispatch(setLoading(false));

    dispatch(buscarGradePremiacao(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarGradePremiacao = createAsyncThunk("/GradePremiacao/buscarGradePremiacao", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/GradePremiacao/buscarGradePremiacao", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarGradePremiacaoPorId = createAsyncThunk("/GradePremiacao/buscarGradePremiacaoPorId", async (id: number) => {
  try {
    const data = await api.get("/GradePremiacao/buscarGradePremiacaoPorId", {
      params: { id: id },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarGradePremiacao = createAsyncThunk("/GradePremiacao/AtualizarGradePremiacao", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/GradePremiacao/AtualizarGradePremiacao/", payload.value);
    toastSucess("Grade de premiação atualizada com sucesso");
    dispatch(setModalCadastrarGradePremiacao(false));
    dispatch(setLoading(false));

    dispatch(buscarGradePremiacao(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarGradePremiacao = createAsyncThunk("/GradePremiacao/DeletarGradePremiacao", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/GradePremiacao/DeletarGradePremiacao", {
      params: { id: payload.value },
    });
    toastSucess("Grade de premiação removida com sucesso");
    dispatch(setModalDeletarGradePremiacao(false));
    dispatch(setLoading(false));

    dispatch(buscarGradePremiacao(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
